import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e7d06a3a")

_pushScopeId("data-v-e7d06a3a")
const _hoisted_1 = {
  class: "inventory-summary-item",
  "data-test": "inventorySummaryItem"
}
const _hoisted_2 = { class: "inventory" }
const _hoisted_3 = { class: "inventory__name" }
const _hoisted_4 = { class: "inventory__quantity" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "edit" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-th-large" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.inventory.name), 1),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.inventory.quantity) + " UN", 1)
    ]),
    _hoisted_5
  ]))
})